import React from 'react';
import { Send, Users, Mail, Copy, ExternalLink } from 'lucide-react';
import { CONTACT_INFO } from '../data/sponsors';
import { motion } from 'framer-motion';
import { toast } from 'sonner';

const Contact = () => {
  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success(`${label} kopyalandi!`);
    }).catch(() => {
      toast.error('Kopyalama basarisiz oldu.');
    });
  };

  return (
    <div style={{ padding: '3rem 0' }}>
      <div className="page-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          style={{ textAlign: 'center', marginBottom: '3rem' }}
        >
          <h1 className="section-title" style={{ fontSize: '2rem' }} data-testid="iletisim-page-title">Iletisim</h1>
          <p className="section-subtitle">Bize ulasmanin en kolay yollari</p>
        </motion.div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '1.5rem',
          maxWidth: '900px',
          margin: '0 auto'
        }}>
          {/* TELEGRAM */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            viewport={{ once: true }}
          >
            <div className="contact-card" data-testid="contact-method-card-telegram">
              <div className="contact-icon">
                <Send size={24} />
              </div>
              <h3 className="contact-title">Telegram</h3>
              <p className="contact-detail">{CONTACT_INFO.telegram.handle}</p>
              <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                <a
                  href={CONTACT_INFO.telegram.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-btn contact-btn-primary"
                  data-testid="contact-telegram-open-button"
                >
                  Ac <ExternalLink size={14} />
                </a>
                <button
                  className="contact-btn contact-btn-secondary"
                  onClick={() => copyToClipboard(CONTACT_INFO.telegram.handle, 'Telegram')}
                  data-testid="contact-telegram-copy-button"
                >
                  Kopyala <Copy size={14} />
                </button>
              </div>
            </div>
          </motion.div>

          {/* TEAMS */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <div className="contact-card" data-testid="contact-method-card-teams">
              <div className="contact-icon">
                <Users size={24} />
              </div>
              <h3 className="contact-title">Microsoft Teams</h3>
              <p className="contact-detail">Canli gorusme icin Teams'e katilin</p>
              <a
                href={CONTACT_INFO.teams.url}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-btn contact-btn-primary"
                data-testid="contact-teams-open-button"
              >
                Teams'e Katil <ExternalLink size={14} />
              </a>
            </div>
          </motion.div>

          {/* EMAIL */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="contact-card" data-testid="contact-method-card-email">
              <div className="contact-icon">
                <Mail size={24} />
              </div>
              <h3 className="contact-title">E-posta</h3>
              <p className="contact-detail">{CONTACT_INFO.email.address}</p>
              <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                <a
                  href={`mailto:${CONTACT_INFO.email.address}`}
                  className="contact-btn contact-btn-primary"
                  data-testid="contact-email-open-button"
                >
                  E-posta Gonder <ExternalLink size={14} />
                </a>
                <button
                  className="contact-btn contact-btn-secondary"
                  onClick={() => copyToClipboard(CONTACT_INFO.email.address, 'E-posta')}
                  data-testid="contact-email-copy-button"
                >
                  Kopyala <Copy size={14} />
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
